var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FA9E14",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6279 11.3531C19.9877 10.599 21.7174 11.0945 22.4773 12.4421L29.746 25.0572C29.906 25.4338 29.976 25.7399 29.996 26.058C30.036 26.8012 29.776 27.5236 29.2661 28.0795C28.7562 28.6334 28.0663 28.9604 27.3164 29H12.6789C12.369 28.9812 12.059 28.9108 11.7691 28.8018C10.3193 28.2172 9.61942 26.5723 10.2093 25.1464L17.5281 12.4332C17.778 11.9863 18.158 11.6008 18.6279 11.3531ZM19.9977 23.2726C19.5178 23.2726 19.1178 23.669 19.1178 24.1456C19.1178 24.6202 19.5178 25.0176 19.9977 25.0176C20.4776 25.0176 20.8675 24.6202 20.8675 24.1347C20.8675 23.66 20.4776 23.2726 19.9977 23.2726ZM19.9977 17.0904C19.5178 17.0904 19.1178 17.4759 19.1178 17.9525V20.7557C19.1178 21.2314 19.5178 21.6287 19.9977 21.6287C20.4776 21.6287 20.8675 21.2314 20.8675 20.7557V17.9525C20.8675 17.4759 20.4776 17.0904 19.9977 17.0904Z",
    fill: "#FA9E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToastIcon);
export default __webpack_public_path__ + "static/media/warning-toast-icon.62c430db92c7e3efc5b497ac78c1e781.svg";
export { ForwardRef as ReactComponent };